const role = {
  Admin: 1,
  User: 3,
  CityAdmin: 2,
  TerminalAdmin: 4,
  moderator: 5,
};

module.exports = { role };
